
import Header from "./Header";
import Codes from "./Codes";
import Result from "./Result";


const Home =()=>{
    return (
        <>
        <Header/>
        <Codes/>
        <Result/>
        </>

    )
}
export default Home;
